module.exports = __webpack_public_path__ + "img/plan2.64b60461.png";